import API from '@/lib/API.js'
import comun from './comun.js'
const zonas = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        }
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.get();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Zonas.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let zona = state.Lista.find((x) => x.id_zona == payload)
            commit("select", zona)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_zona: 0,
                Descripcion_zona: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_zona != 0) {
                data = await API.Zonas.modificar(state.Seleccionado);
                str += "Zona modificada"
            } else {
                data = await API.Zonas.alta(state.Seleccionado);
                str += `nueva Zona de alta '${data.Descripcion_zona}'`
            }
            let secs = await API.Zonas.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_zona)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch,
            state
        }, entidad) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (entidad.id_zona != 0) {
                data = await API.Zonas.modificar(entidad);
                str += "Zona modificada"
            } else {
                data = await API.Zonas.alta(entidad);
                str += `nueva Zona de alta '${data.Descripcion_zona}'`
            }
            let secs = await API.Zonas.traerTodos();
            commit("set", secs)
            //commit("select", data)
            dispatch("selectPorId", data.id_zona)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Zonas.eliminar(id);
                str += "Zona eliminada"
            }
            let ents = await API.Zonas.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        get: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default zonas;